import { lazy } from 'react';

import { toast } from 'pixel-react';
import type { RouteObject } from 'react-router-dom';

const ExecutionConfiguration = lazy(
  () => import('@/pages/Configuration/execution/ExecutionConfiguration'),
);

const WarningModal = lazy(
  () => import('@/components/modal/warningModal/RunConfigWarningModal'),
);

const SlackCreateEditInstance = lazy(
  () => import('suites/CreateEditSlackInstance'),
);
const TeamsCreateEditInstance = lazy(
  () => import('suites/CreateEditTeamsInstance'),
);
const RecipientDrawer = lazy(() => import('suites/RecipientDrawer'));
const CreateEditGroup = lazy(() => import('suites/CreateEditEmailGroup'));

export const ExecutionConfigRoutes: RouteObject[] = [
  {
    path: '/configuration/execution-configuration/*',
    element: <ExecutionConfiguration />,
    children: [
      {
        path: 'run-config/warning-modal/:buttonName',
        element: <WarningModal />,
      },
      {
        path: 'report-config/email-recipient',
        element: <RecipientDrawer />,
      },
      {
        path: 'report-config/slack-recipient',
        element: <RecipientDrawer />,
      },
      {
        path: 'report-config/create-group',
        element: <CreateEditGroup mode="create" toast={toast} />,
      },
      {
        path: 'report-config/create-slack',
        element: <SlackCreateEditInstance isInstanceOpen isIntegration />,
      },
      {
        path: 'report-config/create-teams',
        element: <TeamsCreateEditInstance isInstanceOpen isIntegration />,
      },
    ],
  },
];
